export const isTerminalRun = run => ['completed', 'failed', 'held'].includes(run?.status);

const hasToolSlots = flow => flow?.stations?.some(station => station.execution?.toolSlots?.length > 0);
export const usesControlledExecution = flow => flow.controlledExecution === true || flow.executionPolicy?.enabled === true || hasToolSlots(flow)
  || flow.releasedSnapshots?.some(snapshot => snapshot.content?.executionPolicy?.enabled === true || hasToolSlots(snapshot.content));

export function formatDuration(seconds) {
  const total = Math.max(0, Math.ceil(Number(seconds) || 0));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const remaining = total % 60;
  return [hours, minutes, remaining].map(value => String(value).padStart(2, '0')).join(':');
}

export function makeRunDraft(run) {
  const station = run.snapshot?.station || {};
  const saved = new Map((run.results || []).map(result => [result.key, result]));
  const results = (station.execution?.checkpoints || []).map(checkpoint => ({
    key: checkpoint.key,
    outcome: saved.get(checkpoint.key)?.outcome || '',
    value: saved.get(checkpoint.key)?.value ?? '',
    evidenceIds: [...(saved.get(checkpoint.key)?.evidenceIds || [])],
    notes: saved.get(checkpoint.key)?.notes || ''
  }));
  const materials = (station.parts || []).map((part, index) => {
    const previous = (run.scannedMaterials || []).find(material => material.partNumber === part.partNumber);
    return {
      partNumber: part.partNumber || '', name: part.name || '',
      quantity: part.quantity ?? 1, unit: part.unit || 'pcs',
      confirmed: previous?.confirmed === true,
      scannedValue: previous?.scannedValue || '',
      localKey: `${part.partNumber || 'part'}-${index}`
    };
  });
  return { results, materials, notes: run.notes || '' };
}

export function serializeRunDraft(draft, checkpoints) {
  const definitions = new Map(checkpoints.map(checkpoint => [checkpoint.key, checkpoint]));
  const results = draft.results.filter(result => {
    if (!result.outcome && (result.value !== '' || result.notes || result.evidenceIds.length)) {
      throw new Error(`Choose an outcome for ${definitions.get(result.key)?.label || result.key} before saving.`);
    }
    return Boolean(result.outcome);
  }).map(result => {
    const checkpoint = definitions.get(result.key);
    if (['fail', 'hold'].includes(result.outcome) && !result.notes.trim()) {
      throw new Error(`Enter a reason for the ${result.outcome} result on ${checkpoint?.label || result.key}.`);
    }
    if (checkpoint?.resultType === 'number' && result.value !== '' && !Number.isFinite(Number(result.value))) {
      throw new Error(`Enter a valid number for ${checkpoint.label || checkpoint.key}.`);
    }
    return {
      ...result,
      value: checkpoint?.resultType === 'number' && result.value !== '' ? Number(result.value) : result.value
    };
  });
  return {
    results,
    scannedMaterials: draft.materials.map(({ localKey, ...material }) => material),
    notes: draft.notes
  };
}
